
import {Component, Vue} from 'vue-property-decorator';
import {IsEntity} from '@/entity/IsEntity';
import {PersonelEntity} from '@/entity/PersonelEntity';
import {StatusCodeHelper} from '@/helpers/StatusCodeHelper';

@Component({
  components: {}
})
export default class TopluIsAtama extends Vue {
  step = 1;
  atananKisi: any | null = null;
  atanacakKisi: any | null = null;
  isler: any[] = [];
  seciliIsler: IsEntity[] = [];
  loading = false;
  transferInProgress = false;
  aktarimSonuclari: any[] = [];
  atananPersoneller: any = [];
  atanacakPersoneller: any = [];
  aktarimSonucMessage:string = ''
  headers = [
    { text: 'İş No', value: 'id', align: 'start' },
    { text: 'Tarih', value: 'tarih' },
    { text: 'İş Adı', value: 'isim' },
    { text: 'Kart No', value: 'takip_id' },
    { text: 'Dosya Numarası', value: 'dosya_esas_no' }
  ];

  resultHeaders = [
    { text: 'İş No', value: 'is_no', align: 'start', class: 'my-header-style' },
    { text: 'İş Adı', value: 'is_adi', class: 'my-header-style' },
    { text: 'Kart No', value: 'takip_id', class: 'my-header-style' }
  ];


  atananKullanicilar(){
    this.$http.get('/api/v1/is/atanan-kullanicilar').then((response) => {
      this.atananPersoneller = response;
    })
  }
  atanacakKullanicilar(){
    this.$http.get('/api/v1/is/atanacak-kullanicilar').then((response) => {
      this.atanacakPersoneller = response;
    })
  }

  async onAtananKisiChange() {
    if (!this.atananKisi) {
      this.isler = [];
      this.seciliIsler = [];
      return;
    }

    this.loading = true;
    this.seciliIsler = [];

    try {
      const response = await this.$http.get(`/api/v1/is/atanan-isler/${this.atananKisi}`);

      if (Array.isArray(response.data)) {
        this.isler = response.data;
      } else if (response.data && Array.isArray(response.data.data)) {
        this.isler = response.data.data;
      } else {
        this.isler = [];
      }

      if (this.isler.length === 0) {
        this.$toast.info('Bu kişiye atanmış iş bulunmamaktadır.');
      }
    } catch (error) {
      StatusCodeHelper.error(error);
      this.isler = [];
    } finally {
      this.loading = false;
    }
  }

  async secilenIsleriAktar() {
    if (!this.atanacakKisi || this.seciliIsler.length === 0) {
      this.$toast.warning('Lütfen atanacak kişiyi seçin ve en az bir iş seçin.');
      return;
    }

    const payload = {
      atanan_kisi: this.atananKisi,
      atanacak_kisi: this.atanacakKisi,
      is_ids: this.seciliIsler.map(is => is.id)
    };

    this.transferInProgress = true;
    this.aktarimSonuclari = [];

    try {
      const response = await this.$http.post('/api/v1/is/transfer-atama', payload);

      // API'den gelen updated_jobs'u işle
      if (response && response.data && response.data.updated_jobs) {
        this.aktarimSonuclari = response.data.updated_jobs.map((job: any) => ({
          is_no: job.id,
          is_adi: job.isim,
          takip_id: job.takip_id
        }));
      }

      this.step = 2;

      // API'den gelen mesajı göster
      if (response.data && response.data.message) {
        this.aktarimSonucMessage = response.data.message;
        this.$toast.success(response.data.message);
      }
    } catch (error) {
      StatusCodeHelper.error(error);
      this.$toast.error('İşler aktarılırken bir hata oluştu.');
    } finally {
      this.transferInProgress = false;
    }
  }

  async tumIsleriAktar() {
    if (!this.atanacakKisi || this.isler.length === 0) {
      this.$toast.warning('Lütfen atanacak kişiyi seçin.');
      return;
    }

    const payload = {
      atanan_kisi: this.atananKisi,
      atanacak_kisi: this.atanacakKisi,
      is_ids: this.isler.map(is => is.id)
    };

    this.transferInProgress = true;
    this.aktarimSonuclari = [];

    try {
      const response = await this.$http.post('/api/v1/is/transfer-atama', payload);

      // API'den gelen updated_jobs'u işle
      if (response && response.data && response.data.updated_jobs) {
        this.aktarimSonuclari = response.data.updated_jobs.map((job: any) => ({
          is_no: job.id,
          is_adi: job.isim,
          takip_id: job.takip_id
        }));
      }

      this.step = 2;

      // API'den gelen mesajı göster
      if (response.data && response.data.message) {
        this.$toast.success(response.data.message);
      }
    } catch (error) {
      StatusCodeHelper.error(error);
      this.$toast.error('İşler aktarılırken bir hata oluştu.');
    } finally {
      this.transferInProgress = false;
    }
  }

  yenidenBaslat() {
    this.step = 1;
    this.atananKisi = null;
    this.atanacakKisi = null;
    this.isler = [];
    this.seciliIsler = [];
    this.aktarimSonuclari = [];
  }
}
